import { recordInviteLinkAccess, recordSpecialInviteLinkAccess } from '@/api/task';
import { POINT_INVITE_CODE, SI_C } from '@/constant';

export function bindPointInviteCode() {
  try {
    // 获取链接中的邀请码
    const params = new URLSearchParams(location.search);
    const pointInviteCode = params.get(POINT_INVITE_CODE);
    const specialPointInviteCode = params.get(SI_C);

    if (pointInviteCode) {
      // 绑定邀请码
      recordInviteLinkAccess({ invite_code: pointInviteCode });
    }

    if (specialPointInviteCode) {
      // 绑定特殊邀请码
      recordSpecialInviteLinkAccess({ invite_code: specialPointInviteCode });
    }
  } catch (error) {
    console.error(error);
  }
}
